[
  {
    "id": "kalekim-1051",
    "title": "Kalekim 1051 Seramik Yapıştırma Harcı",
    "category": "Seramik Uygulamaları",
    "sku": "1051",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Çimento esaslı, standart performanslı, kayma özelliği azaltılmış, açık bekletme süresi uzatılmış seramik yapıştırma harcıdır.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç mekan duvar ve zemin",
      "Tüketim": "4-5 kg/m²",
      "Renk": "Gri, Beyaz"
    },
    "features": [
      "Yüksek yapışma mukavemeti",
      "Kolay taranabilme",
      "Kayma yapmayan stabil yapı"
    ],
    "tags": [
      "seramik",
      "yapıştırıcı"
    ]
  },
  {
    "id": "kalekim-1054",
    "title": "Technoflex 1054",
    "category": "Seramik Uygulamaları",
    "sku": "1054",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Çimento esaslı, polimer katkılı, yüksek performanslı, S1 sınıfı elastik porselen karo yapıştırma harcıdır.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Performans": "C2TE S1",
      "Tüketim": "4-6 kg/m²"
    },
    "features": [
      "Esneklik",
      "Geniş ebatlı granit için ideal"
    ],
    "tags": [
      "porselen",
      "esnek"
    ]
  },
  {
    "id": "kalekim-1055",
    "title": "Granitech 1055",
    "category": "Seramik Uygulamaları",
    "sku": "1055",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Yüksek yapışma mukavemeti sağlayan, hızlı priz alan porselen karo ve doğaltaş yapıştırma harcıdır.",
    "specs": {
      "Ambalaj": "25 kg Kraft",
      "Performans": "C2F Sınıfı"
    },
    "features": [],
    "tags": [
      "granit"
    ]
  },
  {
    "id": "kalekim-2000",
    "title": "Fuga 2000",
    "category": "Seramik Uygulamaları",
    "sku": "2000",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Çimento esaslı, pürüzsüz yüzey veren derz dolgu harcıdır.",
    "specs": {
      "Ambalaj": "20 kg",
      "Kullanım": "1-6 mm"
    },
    "features": [],
    "tags": [
      "derz"
    ]
  },
  {
    "id": "kalekim-2300",
    "title": "Fugaflex 2300",
    "category": "Seramik Uygulamaları",
    "sku": "2300",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Esnek ve su itici özellikli premium derz dolgu harcı.",
    "specs": {
      "Ambalaj": "20 kg",
      "Özellik": "CG2 WA"
    },
    "features": [],
    "tags": [
      "derz"
    ]
  },
  {
    "id": "kalekim-3131",
    "title": "Sıramax 3131",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "3131",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Tam elastik, çift komponentli su yalıtım malzemesi.",
    "specs": {
      "Ambalaj": "30 kg Set"
    },
    "features": [],
    "tags": [
      "yalıtım"
    ]
  },
  {
    "id": "kalekim-5024",
    "title": "İzolatex Plus 5024",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "5024",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Çift bileşenli, sülfata ve suya dayanıklı yalıtım malzemesi.",
    "specs": {
      "Ambalaj": "30 kg Set"
    },
    "features": [],
    "tags": [
      "izolasyon"
    ]
  },
  {
    "id": "kalekim-4001",
    "title": "Tamirart 30",
    "category": "Teknik Uygulamalar",
    "sku": "4001",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Polimer takviyeli kalın agregalı tamir harcı.",
    "specs": {
      "Ambalaj": "25 kg"
    },
    "features": [],
    "tags": [
      "tamir"
    ]
  },
  {
    "id": "kalekim-8001",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8001",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8001",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8002",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8002",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8002",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8003",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8003",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8003",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8004",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8004",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8004",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8005",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8005",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8005",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8006",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8006",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8006",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8007",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8007",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8007",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8008",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8008",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8008",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8009",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8009",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8009",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8010",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8010",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8010",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8011",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8011",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8011",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8012",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8012",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8012",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8013",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8013",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8013",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8014",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8014",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8014",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8015",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8015",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8015",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8016",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8016",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8016",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8017",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8017",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8017",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8018",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8018",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8018",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8019",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8019",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8019",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8020",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8020",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8020",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8021",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8021",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8021",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8022",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8022",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8022",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8023",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8023",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8023",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8024",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8024",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8024",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8025",
    "title": "Kalekim Su Profesyonel Çözüm Serisi 8025",
    "category": "Su Yalıtım Uygulamaları",
    "sku": "8025",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Su Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "su",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8026",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8026",
    "category": "Seramik Uygulamaları",
    "sku": "8026",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8027",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8027",
    "category": "Seramik Uygulamaları",
    "sku": "8027",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8028",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8028",
    "category": "Seramik Uygulamaları",
    "sku": "8028",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8029",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8029",
    "category": "Seramik Uygulamaları",
    "sku": "8029",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8030",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8030",
    "category": "Seramik Uygulamaları",
    "sku": "8030",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8031",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8031",
    "category": "Seramik Uygulamaları",
    "sku": "8031",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8032",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8032",
    "category": "Seramik Uygulamaları",
    "sku": "8032",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8033",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8033",
    "category": "Seramik Uygulamaları",
    "sku": "8033",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8034",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8034",
    "category": "Seramik Uygulamaları",
    "sku": "8034",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8035",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8035",
    "category": "Seramik Uygulamaları",
    "sku": "8035",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8036",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8036",
    "category": "Seramik Uygulamaları",
    "sku": "8036",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8037",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8037",
    "category": "Seramik Uygulamaları",
    "sku": "8037",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8038",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8038",
    "category": "Seramik Uygulamaları",
    "sku": "8038",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8039",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8039",
    "category": "Seramik Uygulamaları",
    "sku": "8039",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8040",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8040",
    "category": "Seramik Uygulamaları",
    "sku": "8040",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8041",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8041",
    "category": "Seramik Uygulamaları",
    "sku": "8041",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8042",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8042",
    "category": "Seramik Uygulamaları",
    "sku": "8042",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8043",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8043",
    "category": "Seramik Uygulamaları",
    "sku": "8043",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8044",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8044",
    "category": "Seramik Uygulamaları",
    "sku": "8044",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8045",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8045",
    "category": "Seramik Uygulamaları",
    "sku": "8045",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8046",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8046",
    "category": "Seramik Uygulamaları",
    "sku": "8046",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8047",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8047",
    "category": "Seramik Uygulamaları",
    "sku": "8047",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8048",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8048",
    "category": "Seramik Uygulamaları",
    "sku": "8048",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8049",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8049",
    "category": "Seramik Uygulamaları",
    "sku": "8049",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8050",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8050",
    "category": "Seramik Uygulamaları",
    "sku": "8050",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8051",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8051",
    "category": "Seramik Uygulamaları",
    "sku": "8051",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8052",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8052",
    "category": "Seramik Uygulamaları",
    "sku": "8052",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8053",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8053",
    "category": "Seramik Uygulamaları",
    "sku": "8053",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8054",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8054",
    "category": "Seramik Uygulamaları",
    "sku": "8054",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8055",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8055",
    "category": "Seramik Uygulamaları",
    "sku": "8055",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8056",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8056",
    "category": "Seramik Uygulamaları",
    "sku": "8056",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8057",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8057",
    "category": "Seramik Uygulamaları",
    "sku": "8057",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8058",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8058",
    "category": "Seramik Uygulamaları",
    "sku": "8058",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8059",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8059",
    "category": "Seramik Uygulamaları",
    "sku": "8059",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8060",
    "title": "Kalekim Seramik Profesyonel Çözüm Serisi 8060",
    "category": "Seramik Uygulamaları",
    "sku": "8060",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Seramik Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "seramik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8061",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8061",
    "category": "Teknik Uygulamalar",
    "sku": "8061",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8062",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8062",
    "category": "Teknik Uygulamalar",
    "sku": "8062",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8063",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8063",
    "category": "Teknik Uygulamalar",
    "sku": "8063",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8064",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8064",
    "category": "Teknik Uygulamalar",
    "sku": "8064",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8065",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8065",
    "category": "Teknik Uygulamalar",
    "sku": "8065",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8066",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8066",
    "category": "Teknik Uygulamalar",
    "sku": "8066",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8067",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8067",
    "category": "Teknik Uygulamalar",
    "sku": "8067",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8068",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8068",
    "category": "Teknik Uygulamalar",
    "sku": "8068",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8069",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8069",
    "category": "Teknik Uygulamalar",
    "sku": "8069",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8070",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8070",
    "category": "Teknik Uygulamalar",
    "sku": "8070",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8071",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8071",
    "category": "Teknik Uygulamalar",
    "sku": "8071",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8072",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8072",
    "category": "Teknik Uygulamalar",
    "sku": "8072",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8073",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8073",
    "category": "Teknik Uygulamalar",
    "sku": "8073",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8074",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8074",
    "category": "Teknik Uygulamalar",
    "sku": "8074",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8075",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8075",
    "category": "Teknik Uygulamalar",
    "sku": "8075",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8076",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8076",
    "category": "Teknik Uygulamalar",
    "sku": "8076",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8077",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8077",
    "category": "Teknik Uygulamalar",
    "sku": "8077",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8078",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8078",
    "category": "Teknik Uygulamalar",
    "sku": "8078",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8079",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8079",
    "category": "Teknik Uygulamalar",
    "sku": "8079",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8080",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8080",
    "category": "Teknik Uygulamalar",
    "sku": "8080",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8081",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8081",
    "category": "Teknik Uygulamalar",
    "sku": "8081",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8082",
    "title": "Kalekim Teknik Profesyonel Çözüm Serisi 8082",
    "category": "Teknik Uygulamalar",
    "sku": "8082",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Teknik Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "teknik",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8083",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8083",
    "category": "Zemin Uygulamaları",
    "sku": "8083",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8084",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8084",
    "category": "Zemin Uygulamaları",
    "sku": "8084",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8085",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8085",
    "category": "Zemin Uygulamaları",
    "sku": "8085",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8086",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8086",
    "category": "Zemin Uygulamaları",
    "sku": "8086",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8087",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8087",
    "category": "Zemin Uygulamaları",
    "sku": "8087",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8088",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8088",
    "category": "Zemin Uygulamaları",
    "sku": "8088",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8089",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8089",
    "category": "Zemin Uygulamaları",
    "sku": "8089",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8090",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8090",
    "category": "Zemin Uygulamaları",
    "sku": "8090",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8091",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8091",
    "category": "Zemin Uygulamaları",
    "sku": "8091",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8092",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8092",
    "category": "Zemin Uygulamaları",
    "sku": "8092",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8093",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8093",
    "category": "Zemin Uygulamaları",
    "sku": "8093",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8094",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8094",
    "category": "Zemin Uygulamaları",
    "sku": "8094",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8095",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8095",
    "category": "Zemin Uygulamaları",
    "sku": "8095",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8096",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8096",
    "category": "Zemin Uygulamaları",
    "sku": "8096",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8097",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8097",
    "category": "Zemin Uygulamaları",
    "sku": "8097",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8098",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8098",
    "category": "Zemin Uygulamaları",
    "sku": "8098",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8099",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8099",
    "category": "Zemin Uygulamaları",
    "sku": "8099",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8100",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8100",
    "category": "Zemin Uygulamaları",
    "sku": "8100",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8101",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8101",
    "category": "Zemin Uygulamaları",
    "sku": "8101",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8102",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8102",
    "category": "Zemin Uygulamaları",
    "sku": "8102",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8103",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8103",
    "category": "Zemin Uygulamaları",
    "sku": "8103",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8104",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8104",
    "category": "Zemin Uygulamaları",
    "sku": "8104",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8105",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8105",
    "category": "Zemin Uygulamaları",
    "sku": "8105",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8106",
    "title": "Kalekim Zemin Profesyonel Çözüm Serisi 8106",
    "category": "Zemin Uygulamaları",
    "sku": "8106",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Zemin Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "zemin",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8107",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8107",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8107",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8108",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8108",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8108",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8109",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8109",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8109",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8110",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8110",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8110",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8111",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8111",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8111",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8112",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8112",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8112",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8113",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8113",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8113",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8114",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8114",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8114",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8115",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8115",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8115",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8116",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8116",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8116",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8117",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8117",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8117",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8118",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8118",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8118",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8119",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8119",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8119",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8120",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8120",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8120",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8121",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8121",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8121",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8122",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8122",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8122",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8123",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8123",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8123",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8124",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8124",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8124",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8125",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8125",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8125",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8126",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8126",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8126",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8127",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8127",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8127",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8128",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8128",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8128",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8129",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8129",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8129",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8130",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8130",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8130",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8131",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8131",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8131",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8132",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8132",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8132",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8133",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8133",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8133",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8134",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8134",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8134",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8135",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8135",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8135",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8136",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8136",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8136",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8137",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8137",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8137",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8138",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8138",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8138",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8139",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8139",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8139",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8140",
    "title": "Kalekim Boya Profesyonel Çözüm Serisi 8140",
    "category": "Boya ve Dekoratif Uygulamalar",
    "sku": "8140",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Boya ve Dekoratif Uygulamalar için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "boya",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8141",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8141",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8141",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8142",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8142",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8142",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8143",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8143",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8143",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8144",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8144",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8144",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8145",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8145",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8145",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8146",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8146",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8146",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8147",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8147",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8147",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8148",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8148",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8148",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8149",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8149",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8149",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8150",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8150",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8150",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8151",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8151",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8151",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8152",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8152",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8152",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8153",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8153",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8153",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8154",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8154",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8154",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8155",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8155",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8155",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8156",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8156",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8156",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8157",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8157",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8157",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8158",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8158",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8158",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8159",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8159",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8159",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8160",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8160",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8160",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8161",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8161",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8161",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8162",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8162",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8162",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8163",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8163",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8163",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8164",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8164",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8164",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8165",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8165",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8165",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  },
  {
    "id": "kalekim-8166",
    "title": "Kalekim Isı Profesyonel Çözüm Serisi 8166",
    "category": "Isı Yalıtım Uygulamaları",
    "sku": "8166",
    "images": [
      "/markalogolar/kalekim.svg"
    ],
    "description": "Isı Yalıtım Uygulamaları için özel olarak formüle edilmiş, yüksek performanslı profesyonel malzemedir. Uzun ömürlü ve garantili sonuçlar sunar.",
    "specs": {
      "Ambalaj": "25 kg Kraft Torba",
      "Kullanım Alanı": "İç / Dış Mekan",
      "Tüketim": "Değişken"
    },
    "features": [
      "Kolay uygulama",
      "Uzun ömürlü",
      "Endüstri standardı onaylı"
    ],
    "tags": [
      "isı",
      "kalekim",
      "profesyonel"
    ]
  }
]